import defaultsDeep from 'lodash/defaultsDeep';
import communityBg from './assets/backgrounds/Registration_Community.gif';
import defaultBg from './assets/backgrounds/Registration_Default.gif';
import marketplaceBg from './assets/backgrounds/Registration_Marketplace.jpg';
import oauthBg from './assets/backgrounds/Registration_Oauth.gif';
import teamBg from './assets/backgrounds/Registration_Team.gif';
import { Variant } from './interfaces/registration';

interface VariantMap {
  [id: string]: Variant;
}

const defaults = {
  type: 'default',
  background: {
    image: defaultBg,
    horizontalPosition: 'center',
    verticalPosition: 'center'
  },
  title: 'Create your account',
  subtitle:
    'And start spending more time on your projects and less time managing your infrastructure.'
};

const registrationVariants: VariantMap = {
  primary: defaults,

  marketplace: defaultsDeep(
    {
      type: 'marketplace',
      background: {
        image: marketplaceBg,
        horizontalPosition: 'right'
      },
      title: 'Sign up & deploy – in minutes!',
      subtitle: 'Marketplace solutions let you deploy with a single click!',
      metadata: {
        title:
          'Your {{registrationFormData.marketplace_app.name}} app is a few steps away',
        description: 'You need to create an account on DigitalOcean'
      }
    },
    defaults
  ),

  community: defaultsDeep(
    {
      type: 'community',
      background: {
        image: communityBg
      },
      title: 'All aboard! Join the DigitalOcean Community',
      subtitle: 'Our Community brings developers together. Join us, would you?'
    },
    defaults
  ),

  oauth_app: defaultsDeep(
    {
      type: 'oauth',
      background: {
        image: oauthBg
      },
      title: 'Authorization needed',
      subtitle:
        'In order to use {{registrationFormData.oauth_app.name}}, you’ll need to create a DigitalOcean account.'
    },
    defaults
  ),

  team: defaultsDeep(
    {
      type: 'team',
      background: {
        image: teamBg,
        horizontalPosition: 'center',
        verticalPosition: 'center'
      },
      title: 'Join your team on DigitalOcean!',
      subtitle:
        '{{registrationFormData.team}} has invited you to join them. Sign up and start making waves with your team today!'
    },
    defaults
  )
};

export default registrationVariants;
